/**
 * بنرِ تصویریِ بالای صفحه‌های «برنامه‌های من»، «دوستان» و «کشف» (WHOSUP-157).
 *
 * هر سه بنر عکسِ آماده‌ست (WHOSUP-159)، با دو نسخه‌ی روشن/تیره که با تمِ
 * فعال عوض می‌شن. متن و پس‌زمینه توی خودِ عکسه، پس این‌جا نه چیزی می‌کشیم
 * نه متنی روی بنر می‌ذاریم — فقط alt همون حرف رو به اسکرین‌ریدر می‌زنه.
 * ارتفاعِ بنر هم از نسبتِ خودِ عکس می‌آد (width:100%, height:auto) که هیچ
 * تصویری کشیده یا بریده نشه.
 *
 * روی صفحه‌ی باریک اصلاً ساخته نمی‌شه — خواستِ صریحِ تیکت: «سایز گوشی بنر
 * نداره». ضربدر هم می‌بنددش و انتخاب توی localStorage می‌مونه، پس فقط تا
 * وقتی حرفِ تازه‌ای داره جلوی چشمه.
 *
 * قبل از لاگین بستن ممنوعه (WHOSUP-160): بنر ویترینِ مهمونه، پس برای مهمون
 * ضربدر اصلاً رندر نمی‌شه و بسته‌شدنِ ذخیره‌شده‌ی قبلی هم اعمال نمی‌شه —
 * کسی که لاگین کرده بود و بست، بعد از خروج دوباره بنر رو می‌بینه.
 */
import React, { useState } from 'react';
import { useSession } from '@/core/session';
import { t, useLocale } from '@/core/lib/i18n';
import { tapped } from '@/core/lib/devlog';
import { useIsNarrow } from './useIsNarrow';
import { useTheme } from './theme';
import plansLight from './banners/plans-light.jpg';
import plansDark from './banners/plans-dark.jpg';
import friendsLight from './banners/friends-light.jpg';
import friendsDark from './banners/friends-dark.jpg';
import discoverLight from './banners/discover-light.jpg';
import discoverDark from './banners/discover-dark.jpg';

export type BannerKind = 'plans' | 'friends' | 'discover';

const KEY = (kind: BannerKind) => `whosup.banner.${kind}.v1`;

const ART: Record<BannerKind, { light: string; dark: string }> = {
  plans: { light: plansLight, dark: plansDark },
  friends: { light: friendsLight, dark: friendsDark },
  discover: { light: discoverLight, dark: discoverDark },
};

export function PageBanner({ kind }: { kind: BannerKind }) {
  useLocale();
  const { isDark } = useTheme();
  const { session, loading } = useSession();
  const narrow = useIsNarrow();
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(KEY(kind)) === '1'; } catch { return false; }
  });
  const signedIn = !!session;
  // بسته‌شدنِ ذخیره‌شده فقط برای آدمِ لاگین‌کرده معتبره؛ تا نشست معلوم نشده
  // (loading) هم به همون ذخیره اعتماد می‌کنیم که بنرِ بسته یه پلک ظاهر نشه.
  if (narrow || (hidden && (signedIn || loading))) return null;

  const close = () => {
    setHidden(true);
    try { localStorage.setItem(KEY(kind), '1'); } catch { /* حافظه بسته — فقط همین نشست */ }
  };

  const title = kind === 'plans' ? t('myPlans') : kind === 'friends' ? t('friends') : t('discover');
  const text = kind === 'plans' ? t('plansBannerText')
    : kind === 'friends' ? t('friendsBannerText') : t('discoverBannerText');

  return (
    <section className={`page-banner ${kind}`}>
      <img className="banner-img" src={isDark ? ART[kind].dark : ART[kind].light}
        alt={`${title} — ${text}`} />

      {signedIn && (
        <button type="button" className="banner-x" aria-label={t('filterClose')}
          onClick={tapped('banner-close', close)}>
          ✕
        </button>
      )}
    </section>
  );
}
